export default "__VITE_ASSET__Bn0FSNMQ__"